import * as React from "react";
import { Base } from "ui/Scripts/source/framework/base";
import { ReportType } from "ui/Scripts/source/models/enums";
import { AppUtils } from "../../../framework/appUtils";
import { IReportItem } from "../../../models/report/reportItem";
import { IReportParameterValue } from "../../../models/report/reportParameterValue";
import * as taskService from "../../../models/services/taskService";
import { IReportGenerated2, ReportGenerated2 } from "source/models/report/reportGenerated2";
import { PageReport } from "source/components/framework/Report/PageReport";
import { getTaskGeneralFilterFromFilterState, getTaskGeneralFilterChange, ITaskGeneralFilter, ITaskPageFilterState } from "./TaskPageUtils";

export interface ITaskPageReportProp extends ITaskPageFilterState {
    companyId: string;
    reports: IReportItem[];
    reportId: string;
    dataId?: string;
    onSetSortData: (sortColumn: string, sortOrderIsAsc: boolean) => void;
}

interface ITaskPageReportSearchFilter extends ITaskGeneralFilter {
    report: IReportItem;
}

interface ITaskPageReportState extends ITaskPageReportSearchFilter {
    isLoading: boolean;
    intialized: boolean;
    report: IReportItem;
    reportGenerated: IReportGenerated2;
    reportDataUri: string;
}

export class TaskPageReport extends React.Component<ITaskPageReportProp, ITaskPageReportState> {
    parameterValues: IReportParameterValue[] = [];

    constructor(props: ITaskPageReportProp) {
        super(props);
        const report = props.reportId ? props.reports.find(i => i.id === props.reportId) : null;
        this.parameterValues = report ? report.getReportParameterValues() : [];
        const generalFilterValues = getTaskGeneralFilterFromFilterState(props);
        this.state = {
            ...generalFilterValues,
            isLoading: false,
            intialized: false,
            reportGenerated: null,
            reportDataUri: "",
            report: props.reportId ? props.reports.find(i => i.id === props.reportId) : null,
        };
    }

    createReport = async (searchFilter: ITaskPageReportSearchFilter) => {
        const props = this.props;
        if (!searchFilter.report) return;
        let reportGenerated: ReportGenerated2 = null;
        if (searchFilter.report.type !== ReportType.Html) {
            this.setState({ isLoading: true });
            reportGenerated = await AppUtils.callService(() => taskService.getReportGenerated(props.companyId, searchFilter.report.reportId, searchFilter.report.title, false,
                searchFilter.unitIds, searchFilter.stateIds, searchFilter.priorityIds, searchFilter.taskTypeIds, searchFilter.handlerUserCodes, searchFilter.personInChargeUserCodes,
                searchFilter.taskTypeHeaderFields, searchFilter.taskTypeFields, this.parameterValues), false, false, () => { this.setState({ isLoading: false }); });
            if (!reportGenerated) return;
        }
        const reportBlob = searchFilter.report.type === ReportType.Pdf && reportGenerated && reportGenerated.content
            ? Base.base64ToBlob(reportGenerated.content, reportGenerated.mediaType)
            : null;
        const reportDataUri = reportBlob
            ? await Base.blobToBase64(reportBlob)
            : "";
        this.setState({
            ...searchFilter,
            intialized: true,
            reportGenerated,
            reportDataUri
        });
    };

    componentDidMount(): void {
        this.createReport(this.state);
    }

    componentDidUpdate(prevProps: ITaskPageReportProp, prevState: ITaskPageReportState) {
        const props = this.props;
        const prevDataId = prevProps.dataId ? prevProps.dataId : "";
        const dataId = props.dataId ? props.dataId : "";
        const prevCompanyId = prevProps.companyId ? prevProps.companyId : "";
        const companyId = props.companyId ? props.companyId : "";
        const prevReportId = prevProps.reportId ? prevProps.reportId : "";
        const reportId = props.reportId ? props.reportId : "";
        const filterStateChange = getTaskGeneralFilterChange(prevProps, props);
        const report = props.reportId ? props.reports.find(i => i.id === props.reportId) : null;
        const parameterValues = report ? report.getReportParameterValues() : [];
        if (dataId === prevDataId && companyId === prevCompanyId && reportId === prevReportId &&
            filterStateChange.notChanged &&
            Base.equalStrArrays(prevProps.reports ? prevProps.reports.map(i => i.id) : [], props.reports ? props.reports.map(i => i.id) : []) &&
            JSON.stringify(this.parameterValues) === JSON.stringify(parameterValues)) return;
        this.parameterValues = parameterValues;
        this.createReport({ ...filterStateChange, report: reportId ? props.reports.find(i => i.id === reportId) : null });
    }

    render() {
        const props = this.props;
        const state = this.state;
        return (
            <PageReport
                isLoading={state.isLoading}
                report={state.report}
                reportGenerated={state.reportGenerated}
                reportDataUri={state.reportDataUri}
                sortingDisabled={true}
                onSetSortData={props.onSetSortData}
            />
        );
    }
}